import { forwardRef, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import { Popup, PopupComponentProps } from '@atlaskit/popup';

import { useIntl } from 'src/hooks/intl';
import {
  changeIsCreateIssueDialogOpen,
  fetchJiraTabCreateIssueUserPreferences,
} from 'src/redux/jira/actions';
import { BucketState } from 'src/types/state';

import { CreateJiraIssueJiraTab } from '../create-jira-issue/create-jira-issue-jira-tab';

import messages from './create-jira-issue-inline-dialog.i18n';
import * as styles from './create-jira-issue-inline-dialog.styled';

type Props = {
  isDisabled: boolean;
};

export const CustomPopupContainer = forwardRef<
  HTMLDivElement,
  PopupComponentProps
>(({ children, ...props }, ref) => (
  <styles.CustomPopupContainer {...props} ref={ref}>
    {children}
  </styles.CustomPopupContainer>
));

export const CreateJiraIssueInlineDialog = ({ isDisabled }: Props) => {
  const intl = useIntl();
  const isCreateIssueDialogOpen = useSelector<BucketState, boolean>(
    state => state.jira.jiraRepoPage.isCreateIssueDialogOpen
  );
  const dispatch = useDispatch();
  const onClose = () => dispatch(changeIsCreateIssueDialogOpen(false));

  useEffect(() => {
    dispatch(fetchJiraTabCreateIssueUserPreferences());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Popup
      autoFocus={false}
      isOpen={isCreateIssueDialogOpen}
      onClose={onClose}
      placement="bottom-end"
      content={() => (
        <styles.CreateJiraIssueContainer>
          <CreateJiraIssueJiraTab closeDialog={onClose} />
        </styles.CreateJiraIssueContainer>
      )}
      trigger={triggerProps => (
        <CustomThemeButton
          {...triggerProps}
          isDisabled={isDisabled}
          isSelected={isCreateIssueDialogOpen}
          onClick={() =>
            dispatch(changeIsCreateIssueDialogOpen(!isCreateIssueDialogOpen))
          }
        >
          {intl.formatMessage(messages.createIssue)}
        </CustomThemeButton>
      )}
      popupComponent={CustomPopupContainer}
    />
  );
};
